export function sourceUrl(source: any, pageNumber = 0) {
  return `${source.file ? source.file.url : source.url}#page=${pageNumber}`;
}
